import {
  CloseButton,
  FormControl,
  FormErrorIcon,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Tooltip,
} from '@chakra-ui/react';
import { mdiMagnify } from '@mdi/js';
import { PortalIcon } from 'features/common/components/PortalIcon';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  isValid: boolean;
}

export const SearchGroupMemberInput = ({
  value,
  onChange,
  onClear,
  isValid,
}: SearchInputProps) => (
  <FormControl isInvalid={!isValid}>
    <InputGroup mb='4' maxWidth='sm'>
      <InputLeftElement
        pointerEvents='none'
        children={<PortalIcon path={mdiMagnify} />}
      />
      <Input
        placeholder='Search'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid='member_search_input'
      />
      {value.length > 0 && (
        <InputRightElement>
          <Tooltip label='Clear search'>
            <CloseButton onClick={onClear} />
          </Tooltip>
        </InputRightElement>
      )}
    </InputGroup>
    {!isValid && (
      <FormErrorMessage>
        <FormErrorIcon />
        Currently, the search is only available in alphanumeric characters, at
        signs (@), dots, dashes, and underscores.
      </FormErrorMessage>
    )}
  </FormControl>
);
